module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"BugsCount":"Nombre d\u0027anomalies causées","ProjectsName":"Nom des projets","Ratio":"Ratio","TotalHours":"Nombre d\u0027heures travaillées"}}')
  delete Component.options._Ctor
}
